import styled, { css } from 'styled-components'
import { Tab, Tabs } from '@material-ui/core'
import { TabsProps } from '.'
import theme from 'presentation/styles/theme'

export const Wrapper = styled.div<Pick<TabsProps, 'wrapperMaxWidth'>>`
  width: 100%;
  max-width: ${({ wrapperMaxWidth }) =>
    wrapperMaxWidth ? wrapperMaxWidth : 'unset'};

  & .MuiTabs-root {
    min-height: 36px;
  }
`

export const StyledTabs = styled(Tabs)<
  Pick<TabsProps, 'borderColor' | 'activeColor' | 'tabsMaxWidth'>
>`
  ${({ borderColor, activeColor, tabsMaxWidth }) => css`
    max-width: ${tabsMaxWidth ? tabsMaxWidth : 'unset'};

    & .MuiTabs-flexContainer {
      border-bottom: 2px solid ${theme.ds.colors[borderColor!]};
    }

    & .MuiTabs-indicator {
      background-color: ${theme.ds.colors[activeColor!]};
    }
  `}
`

export const StyledTab = styled(Tab)<Pick<TabsProps, 'activeColor'>>`
  ${({ theme, activeColor }) => css`
    & .MuiTab-wrapper {
      color: ${({ theme }) => theme.ds.colors.neutral700};
      font-weight: 600;
      font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
    }

    &.MuiTab-root {
      font-size: 16px;
      padding: 8px 24px;
      width: 100%;
      min-width: auto;
      max-width: fit-content;
      font-family: ${theme.ds.typography.fontFamily} !important;
      min-height: 36px;
      text-transform: none !important;
    }

    &.Mui-selected {
      & .MuiTab-wrapper {
        color: ${theme.ds.colors[activeColor!]};
        font-weight: 600;
    }
  `}
`

export const ActiveTabPanel = styled.div``
